import React from "react";
import WinningVouchers from "../modules/WinningVouchers/WinningVouchers";

const WinningVouchersPage = () => (
    <WinningVouchers/>
)

export default WinningVouchersPage